import { TypeKeys, ActionTypes } from '../actions/index';
import { subscribeToSelectedAssignmentMembers } from '../components/sw-app/sw-portal/portal-firestore';

const getInitialState = (): PortalState => {
  return {
    org: {
      id: null,
      name: null,
      owner: null,
      totalActivatedRedemptions: 0,
      totalRedemptionsLeft: 0,
      totalAvailableRedemptions: 0,
      editors: [],
      adminSeatLimit: 0,
      orgType: null,
    },
    orgError: null,
    assignments: [],
  };
};

const portal = (
  state = getInitialState(),
  action: ActionTypes
): PortalState => {
  switch (action.type) {
    case TypeKeys.SET_ORG: {
      return {
        ...state,
        org: action.org,
        orgError: action.error
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
    case TypeKeys.SET_ORG_ASSIGNMENTS: {
      return {
        ...state,
        assignments: action.assignments,
      };
    }
    case TypeKeys.GET_ASSIGNED_MEMBERS: {
      let newAssignedMembers: AssignedMember[] = [];
      subscribeToSelectedAssignmentMembers(
        action.assignmentId,
        (assignedMembers) => {
          newAssignedMembers = [...assignedMembers];
        }
      );
      const updatedAssignments = state.assignments.map((assignment) => {
        if (assignment.assignmentId === action.assignmentId) {
          assignment.assignedMembers = newAssignedMembers;
        }
        return assignment;
      });

      return {
        ...state,
        assignments: updatedAssignments,
      };
    }

    case TypeKeys.UPDATE_ASSIGNMENT: {
      const updatedAssignments = state.assignments.map((assignment) =>
        assignment.assignmentId === action.updatedAssignment?.assignmentId
          ? (assignment = action.updatedAssignment)
          : assignment
      );
      return {
        ...state,
        assignments: updatedAssignments,
      };
    }
  }
  return state;
};

export default portal;
